var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-animation"},[_c('i',{staticClass:"loading-animation__icon fas fa-cog fa-spin"}),(_vm.hasSlot)?_c('span',{staticClass:"loading-animation__text"},[_vm._t("default")],2):_c('span',{staticClass:"loading-animation__text"},[_vm._v("Loading…")])])
}
var staticRenderFns = []

export { render, staticRenderFns }